import appEn from '../locales/app_en.json';
import appFr from '../locales/app_fr.json';

const LOCALE_STORAGE_KEY = 'chainsight-locale';
const SUPPORTED_LOCALES = ['en', 'fr'];
const DEFAULT_LOCALE = 'en';

const rawByLocale = { en: appEn, fr: appFr };

function isMetaKey(key) {
  return typeof key === 'string' && key.startsWith('@');
}

function buildMessages(raw) {
  const messages = {};
  for (const key of Object.keys(raw)) {
    if (!isMetaKey(key)) {
      messages[key] = raw[key];
    }
  }
  return messages;
}

const messagesCache = {};
if (rawByLocale.en) messagesCache.en = buildMessages(rawByLocale.en);
if (rawByLocale.fr) messagesCache.fr = buildMessages(rawByLocale.fr);

export function getStoredLocale() {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (SUPPORTED_LOCALES.includes(stored)) return stored;
  } catch (_) {}
  return DEFAULT_LOCALE;
}

export function setStoredLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch (_) {}
}

export function getMessagesSync(locale) {
  const safeLocale = SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
  return messagesCache[safeLocale] || messagesCache[DEFAULT_LOCALE] || {};
}

export async function loadArb(locale) {
  return Promise.resolve(getMessagesSync(locale));
}

export function t(messages, key, params = {}) {
  if (!messages || typeof messages[key] !== 'string') {
    return key;
  }
  let str = messages[key];
  for (const [k, v] of Object.entries(params)) {
    str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
  }
  return str;
}

export { SUPPORTED_LOCALES, DEFAULT_LOCALE };
